import { createAsyncThunk } from "@reduxjs/toolkit";
import { customer_list } from "../../../mock/DigitalMarketing/customerList";
import { getDashboard } from "../../../Service/api/ApiUrls";
import axios from '../../../Service/axios'

export const GetcustomerList = createAsyncThunk(
  `dashboard/customerlist`,
  async () => {
    const res = axios.get(getDashboard);
    return res;
  }
);
